import api from './index';

// Get all unread notifications
export const getAllUnreadNotifications = () => {
  return api.get('/notifications/unread');
};

// Mark all notifications as read
export const markAllAsRead = () => api.post('/notifications/mark-read');
